var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerWitTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1001 8.00008C8.1001 8.84876 8.43724 9.66268 9.03735 10.2628C9.63746 10.8629 10.4514 11.2 11.3001 11.2C12.1487 11.2 12.9627 10.8629 13.5628 10.2628C14.1629 9.66268 14.5 8.84876 14.5 8.00008C14.5 7.15139 14.1629 6.33747 13.5628 5.73736C12.9627 5.13725 12.1487 4.80011 11.3001 4.80011C10.4514 4.80011 9.63746 5.13725 9.03735 5.73736C8.43724 6.33747 8.1001 7.15139 8.1001 8.00008Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49997 19.1999V17.5999C6.49997 16.7512 6.83711 15.9373 7.43722 15.3372C8.03733 14.737 8.85125 14.3999 9.69994 14.3999H12.8999",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7001 17.5993L15.3001 19.1992L18.5001 15.9993",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerWitTick);
export default __webpack_public_path__ + "static/media/per_witTick.9d71c6f2af01910180051b2ed36abc74.svg";
export { ForwardRef as ReactComponent };